import { styled, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ShareIcon } from "src/components/icons/ShareIcon";
import { UsersIcon } from "src/components/icons/UsersIcon";
import type { CASE_SHARE_FILTER } from "src/types";

interface Props {
  value: CASE_SHARE_FILTER;
  onChange: (value: CASE_SHARE_FILTER) => void;
}

export function CaseShareFiltersBar(props: Props) {
  const { value, onChange } = props;
  const { t } = useTranslation();
  return (
    <Styles value={value} onChange={(_, newValue) => onChange(newValue)}>
      <Tab label={t("label.allCases")} value="ALL" />
      <Tab label={t("label.sharedByMe")} value="SHARED_BY_ME" icon={<ShareIcon />} iconPosition="start" />
      <Tab label={t("label.sharedWithMe")} value="SHARED_WITH_ME" icon={<UsersIcon />} iconPosition="start" />
    </Styles>
  );
}

const Styles = styled(Tabs)`
  border-radius: 4px;
  min-height: unset;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  .MuiTabs-indicator {
    display: none;
  }

  .MuiTab-root {
    min-height: unset;
    text-transform: none;
    font-weight: bold;
    padding: ${({ theme }) => theme.spacing(1, 2)};
    &.Mui-selected {
      background-color: ${({ theme }) => theme.palette.primary.main};

      border-radius: 8px;
      color: white;
      box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    }
    .MuiSvgIcon-root {
      font-size: 14px;
      transform: translateY(-1px);
    }
  }
`;
